import { render, staticRenderFns } from "./approveMoveToStore.vue?vue&type=template&id=4b87ab2d"
import script from "./approveMoveToStore.vue?vue&type=script&lang=js"
export * from "./approveMoveToStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports